import { AbstractVpaDataTableReport } from '../../report/abstract-vpa-data-table-report';
import ActiveFiltersInterface from '@vertical-plus/vue-js-components/lib/model/vos/search/active-filters-interface';
import ClientSearchConditionsInterface from '@/model/vo/client/client-search-conditions-interface';
import ClientSearchResultsVo from '@/model/vo/client/client-search-results-vo';
import ColumnInterface from '@vertical-plus/vue-js-components/lib/model/vos/report/column-interface';
import FilterInterface from '@vertical-plus/vue-js-components/lib/model/vos/search/filter-interface';
import SortByInterface from '@vertical-plus/vue-js-components/lib/model/vos/report/sort-by-interface';
import WidgetInterface from '@vertical-plus/vue-js-components/lib/model/vos/report/widget-interface';

export default class ClientDataTableReport extends AbstractVpaDataTableReport
{
    public id = 'clients';

    public get widgets(): WidgetInterface[]
    {
        return [];
    }

    public get filters(): FilterInterface[]
    {
        return [
            {
                key: 'id',
                type: 'string',
                title: this.i18n('general.field.id'),
            },
            {
                key: 'name',
                type: 'string',
                title: this.i18n('general.field.name'),
            },
            {
                key: 'archived',
                type: 'boolean',
                title: this.i18n('general.field.archived'),
            },
            {
                key: 'disabled',
                type: 'boolean',
                title: this.i18n('general.field.disabled'),
            },
        ];
    }

    public get defaultFilters(): ActiveFiltersInterface
    {
        return {
            archived: false,
            disabled: false,
        };
    }

    public get columns(): ColumnInterface[]
    {
        return [
            {
                key: 'id',
                title: this.i18n('general.field.id'),
                width: 100,
            },
            {
                key: 'name',
                title: this.i18n('general.field.name'),
            },
            {
                key: 'archived',
                title: this.i18n('general.field.archived'),
                width: 80,
                align: 'center',
            },
            {
                key: 'disabled',
                title: this.i18n('general.field.disabled'),
                width: 80,
                align: 'center',
            },
            {
                key: 'dateCreated',
                title: this.i18n('general.field.date_created'),
                width: 150,
            },
            {
                key: 'options',
                title: this.i18n('general.field.options'),
                width: 80,
                align: 'end',
            },
        ];
    }

    public get defaultColumns(): string[]
    {
        if (this.savedDefaultColumns)
        {
            return this.savedDefaultColumns;
        }

        return [
            'id',
            'name',
            'archived',
            'disabled',
            'dateCreated',
            'options',
        ];
    }

    public get sortBys(): SortByInterface[]
    {
        return [
            {
                key: 'id',
                title: this.i18n('general.field.id'),
                order:
                [
                    {
                        key: 'id',
                        descending: false,
                    },
                ],
            },
            {
                key: 'name',
                title: this.i18n('general.field.name'),
                order:
                [
                    {
                        key: 'name',
                        descending: false,
                    },
                ],
            },
            {
                key: 'dateCreated',
                title: this.i18n('general.field.date_created'),
                order:
                [
                    {
                        key: 'dateCreated',
                        descending: true,
                    },
                ],
            },
        ];
    }

    public defaultSortBy = 'dateCreated';

    private results: ClientSearchResultsVo|null = null;

    public async loadResults(conditions: ClientSearchConditionsInterface): Promise<ClientSearchResultsVo>
    {
        const results = await this.serviceContainer.clientService.findClients(conditions);

        this.results = Object.assign({}, results);

        return results;
    }
}